// @flow
import React, { type Element } from 'react';
import { Row, Col } from 'angieslist-react-components';
import './GenericCard.scss';

type Props = {
    // purposely 'any' because we are going to pass a variety of stuff through here
    children: any
};

export const GenericCard = ({ children }: Props): Element<"div"> => (
  <div id="Generic-Card--Container">
    <div className="single-card">
      <div className="card-container">
        <Row className="card-body-padding">
          <Col xs={12}>
            {children}
          </Col>
        </Row>
      </div>
    </div>
  </div>
);

export default(GenericCard);



// WEBPACK FOOTER //
// ./src/modules/home/browser/components/DashboardV2/Card/GenericCard.js